/** Float tolerance when comparing summed % delivery to 100. */
const DELIVERY_SUM_EPSILON = 1e-6;

export function sumRateCardsDeliveryPercentage(
  rows: Array<{ deliveryPercentage?: number | string | null | undefined }>
): number {
  return rows.reduce((sum, r) => {
    const n = Number(r.deliveryPercentage);
    return sum + (Number.isFinite(n) ? n : 0);
  }, 0);
}

export function isTotalDeliveryPercentageOver100(
  rows: Array<{ deliveryPercentage?: number | string | null | undefined }>
): boolean {
  return sumRateCardsDeliveryPercentage(rows) > 100 + DELIVERY_SUM_EPSILON;
}
